import { memo } from "react"

import styled from "styled-components"

import { borderRadius, colors, spacing, typography, size } from "@izettle/otto"

export const SelectValueContainer = memo(styled.div`
  ${typography.regular}
  margin: 0 ${spacing.small};
  flex: 1;
  display: flex;
  border-radius: ${borderRadius.large};
  border: none;
  outline: none;
  padding: 0;
  min-width: 0;
  transition: color 0.1s cubic-bezier(0.25, 0.1, 0.25, 1);
  &:disabled {
    background: none;
    cursor: not-allowed;
    color: ${colors.text.disabled};
  }
  align-items: center;
  justify-content: flex-start;
`)

export const SelectValueContainerText = memo(styled.div<{ isDisabled: boolean }>`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  line-height: ${size.large};
  min-width: 0;
  max-width: 100%;
  width: fit-content;
  text-overflow: ellipsis;
  ${({ isDisabled }) => isDisabled && `color: ${colors.text.disabled}`}
`)

export const SelectValueContainerCounter = memo(styled.div<{ isVisible: boolean }>`
  flex: 0;
  pointer-events: none;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
`)
